<div class="content__inner">
    <header class="content__title">
        <h1>{{ "orderitems.detail.title" | translate }}</h1>

        <div class="actions">
            <button (click)="back()" class="btn btn-secondary btn--icon-text"><i class="zmdi zmdi-arrow-back"></i> {{ "global.buttons.back" | translate }}</button>
            <button class="float-right btn btn-outline-secondary btn--icon-text" *appHasPermission="'ORDERITEMS.LIST'" (click)="downloadOrdersCSV()"><i class="zmdi zmdi-download"></i> {{ "orderitems.detail.export" | translate }}</button>
        </div>
    </header>

    <div class="card" *appHasPermission="'ORDERITEMS.LIST'">
        <div class="card-body" *ngIf="orderItem !== null">
            <div class="col-md-12" id="orderitem-details" *ngIf="orderItem.user">
                <div class="form-group">
                    <h6>{{ "orderitems.props.user" | translate }}</h6>
                    <div [innerHtml]="orderItem.user.htmlFormatUser()"></div>
                </div>
            </div>

            <!-- Table -->
            <table mat-table [dataSource]="orderItem.orderPositions">
                <ng-container matColumnDef="materialNumber">
                    <th mat-header-cell *matHeaderCellDef>{{ "orderitems.props.materialnumber" | translate }}</th>
                    <td mat-cell *matCellDef="let row">{{ row.item.materialNumber }}</td>
                </ng-container>

                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef>{{ "orderitems.props.name" | translate }}</th>
                    <td mat-cell *matCellDef="let row">{{ row.item.name }}</td>
                </ng-container>

                <ng-container matColumnDef="category">
                    <th mat-header-cell *matHeaderCellDef>{{ "orderitems.props.category" | translate }}</th>
                    <td mat-cell *matCellDef="let row">{{ row.getCategoryI18N() | translate }}</td>
                </ng-container>

                <ng-container matColumnDef="quantity">
                    <th mat-header-cell *matHeaderCellDef>{{ "orderitems.props.quantity" | translate }}</th>
                    <td mat-cell *matCellDef="let row">{{ row.quantity }}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
        </div>
    </div>
</div>
